import { buildApiUrl } from "../../services/apiConfig";
import { v4 as uuidv4 } from 'uuid';

class AgentWorkflowService {
    getOrGenerateThreadID() {
        let threadID = sessionStorage.getItem("agent_workflow_thread_id");
        if (!threadID) {
            threadID = uuidv4();
            sessionStorage.setItem("agent_workflow_thread_id", threadID);
        }
        return threadID;
    }

    async sendMessage(input, cust_id, userId, runId = null) {
        const formData = new FormData();
        formData.append("query", input);
        formData.append("cust_id", cust_id);
        formData.append("advisor_id", userId);
        formData.append("page_name", "Agent Workflow");
        formData.append("use_case_id", "aw101");
        formData.append("agent_id", "63493");
        if (runId) formData.append("run_id", runId);

        const threadId = this.getOrGenerateThreadID();
        formData.append("thread_id", threadId);

        const response = await fetch(buildApiUrl('NOVA', '/Nova_chat_stream'), {
            method: "POST",
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`Server responded with ${response.status}`);
        }

        return response;
    }

    async sendMessageV2(input, cust_id, userId, templateId = null) {
        const formData = new FormData();
        formData.append("query", input);
        formData.append("cust_id", cust_id);
        formData.append("user_id", userId);
        formData.append("page_name", "Agent Workflow");
        formData.append("use_case_id", "aw101");
        formData.append("agent_id", "63493");
        formData.append("thread_id", this.getOrGenerateThreadID());
        if (templateId !== null) formData.append("template_id", templateId);

        const response = await fetch(buildApiUrl('NOVA_V2', '/Nova_chat_stream'), {
            method: "POST",
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`Server responded with ${response.status}`);
        }
        return response;
    }

    async getSuggestions() {
        try {
            const response = await fetch(buildApiUrl('NOVA_V2', '/flow_templates'));
            if (!response.ok) throw new Error(`Suggestions API responded with ${response.status}`);
            const data = await response.json();
            return (data.templates || []).filter(t => t.enabled);
        } catch (error) {
            console.error('Error fetching suggestions:', error);
            return [];
        }
    }

    async getAgentGraph(advisorId, runId) {
        try {
            const params = new URLSearchParams({ advisor_id: advisorId });
            if (runId) params.append('run_id', runId);
            const response = await fetch(buildApiUrl('NOVA', `/agent_graph/run?${params.toString()}`));

            if (!response.ok) {
                throw new Error(`Failed to fetch workflow graph: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error("Error fetching agent graph:", error);
            throw error;
        }
    }

    async getFullAgentGraph() {
        try {
            const response = await fetch(buildApiUrl('NOVA', `/agent_graph/full`));
            if (!response.ok) {
                throw new Error(`Failed to fetch full workflow graph: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            console.error("Error fetching full agent graph:", error);
            throw error;
        }
    }

    async getFullAgentGraphV2(userId) {
        try {
            const params = userId ? `?user_id=${encodeURIComponent(userId)}` : '';
            const response = await fetch(buildApiUrl('NOVA_V2', `/agent_graph/full${params}`));
            if (!response.ok) {
                throw new Error(`Failed to fetch v2 full workflow graph: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            console.error("Error fetching v2 full agent graph:", error);
            throw error;
        }
    }

    async getAgentGraphRunV2(userId, runId) {
        try {
            const params = new URLSearchParams();
            if (userId) params.append('user_id', userId);
            if (runId) params.append('run_id', runId);
            const query = params.toString() ? `?${params.toString()}` : '';
            const response = await fetch(buildApiUrl('NOVA_V2', `/agent_graph/run${query}`));
            if (!response.ok) {
                throw new Error(`Failed to fetch v2 run graph: ${response.status}`);
            }
            return await response.json();
        } catch (error) {
            console.error("Error fetching v2 run agent graph:", error);
            throw error;
        }
    }
}

export default new AgentWorkflowService();